import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../../api.service';
import { MtnRequest } from './mtn.request';

@Injectable({
  providedIn: 'root',
})
export class MtnApiService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) {}

  createUserAccountMTN(paramsRequest: MtnRequest) {
    const apiUrl = `${this.apiService.API_URL}/patrons`;
    const body = paramsRequest;
    return this.http.post<MtnRequest>(apiUrl, body).pipe(
      map((mtnRequest: MtnRequest) => {
        return mtnRequest;
      }),
      catchError((error: HttpErrorResponse) => {
        throw error.message;
      })
    );
  }
}
